"use strict";

/**
 * @namespace Fotobook.productSubstrates
 */
(function () {

    var self = Fotobook.productSubstrates = {
        substrates: [],
        set: function (data) {
            this.substrates = data;
        },
        get: function (region, variantId, colorId) {
            variantId = variantId || Fotobook.book.project.variant_id;
            colorId = colorId || Fotobook.book.project.color_id;
            return this.substrates.find(function (substrate) {
                return substrate.variant_id === variantId
                    && substrate.color_id === colorId
                    && substrate.region_type === region
                    && substrate.size_id === Fotobook.book.size.id;
            });
        },
        getAll: function () {
            return this.substrates;
        },
    };

    $(document)
        .on(Fotobook.events.AJAX_DONE, function (event, result, response) {
            if (response && response.data && response.data.productSubstrates) {
                self.set(response.data.productSubstrates);
            }
        })
        .on(Fotobook.events.ONLINE_EDITOR_INIT_DATA, function (event, initData) {
            self.set(initData.productSubstrates);
        })
    ;

})();
